// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  margin-top: 6rem;
  display: grid;
  grid-gap: 3.5rem;
}

.title {
  font-size: 2rem;
  line-height: 2.4rem;
  color: var(--black);
}

.nav {
  display: flex;
  gap: 6rem;
}

.link {
  font-size: 1.6rem;
  line-height: 1.9rem;
  letter-spacing: 0.005em;
  color: var(--black);
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  cursor: pointer;
}
.link:after {
  content: "";
  width: 0;
  height: 0.2rem;
  background: var(--primary);
  transition: 0.2s width;
}
.link.active {
  cursor: default;
}
.link.active:after {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/shared/tables/tables/tables.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;AACF;;AAEA;EACE,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;AACF;AACE;EACE,WAAA;EACA,QAAA;EACA,cAAA;EACA,0BAAA;EACA,sBAAA;AACJ;AAEE;EACE,eAAA;AAAJ;AAEI;EACE,WAAA;AAAN","sourcesContent":[":host {\n  margin-top: 6rem;\n  display: grid;\n  grid-gap: 3.5rem;\n}\n\n.title {\n  font-size: 2rem;\n  line-height: 2.4rem;\n  color: var(--black);\n}\n\n.nav {\n  display: flex;\n  gap: 6rem;\n}\n\n.link {\n  font-size: 1.6rem;\n  line-height: 1.9rem;\n  letter-spacing: 0.005em;\n  color: var(--black);\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  cursor: pointer;\n\n  &:after {\n    content: '';\n    width: 0;\n    height: 0.2rem;\n    background: var(--primary);\n    transition: 0.2s width;\n  }\n\n  &.active {\n    cursor: default;\n\n    &:after {\n      width: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
